import initialState from '../store/initialstate';
import C from '../constants/serviceCatalog';

export default (state = initialState().serviceCatalog, action = null) => {
  switch (action.type) {
    case C.SET_CATALOG_ITEMS: {
      state = state.set(C.CATALOG_ITEMS, action.payload);

      if (action.isRemove) {
        state = state.set(C.CURRENT_BRANCHES, removeBranche(state, action));
      } else {
        let currentBranches = state.get(C.CURRENT_BRANCHES) || [];
        state = state.set(C.CURRENT_BRANCHES, [
          ...currentBranches,
          action.branch
        ]);
      }
      return state;
    }
    case C.SET_CATALOG_ITEMS_WITH_BRANCH: {
      state = state.set(C.CATALOG_ITEMS, action.payload);
      state = state.set(C.CURRENT_BRANCHES, action.branch);
      return state;
    }
    case C.ADD_BRANCH_TO_CURRENT_BRANCHES: {
      let currentBranches = state.get(C.CURRENT_BRANCHES) || [];
      state = state.set(C.CURRENT_BRANCHES, [
        ...currentBranches,
        action.branch
      ]);
      return state;
    }
    case C.REMOVE_BRANCH_FROM_CURRENT_BRANCHES: {
      const neweBranche = removeBranche(state, action);
      let newState = state.set(C.CURRENT_BRANCHES, neweBranche);
      return newState;
    }
    case C.SET_SYSAI_CHATBOT_CALALOG_ITEM: {
      return state.set(C.SYSAI_CHATBOT_CALALOG_ITEM, action.payload);
    }
    default:
      return state;
  }
};

function removeBranche(state, action) {
  const branchesArray = [action.branch];

  if (undefined === state.get(C.CURRENT_BRANCHES)) {
    return branchesArray;
  } else {
    let currentBranches = JSON.parse(
      JSON.stringify(state.get(C.CURRENT_BRANCHES))
    );
    let currentBrancID = currentBranches[currentBranches.length - 1].id;
    while (
      currentBranches.length > 0 &&
      currentBrancID != 1 &&
      currentBrancID != action.branch.id
    ) {
      currentBranches.pop();
      if (currentBranches.length > 0) {
        currentBrancID = currentBranches[currentBranches.length - 1].id;
      }
    }
    if (currentBranches.length == 0) {
      return branchesArray;
    } else {
      return currentBranches;
    }
  }
}



// WEBPACK FOOTER //
// ./reducers/serviceCatalog.js